<template>
    <div class="container mt-5">
        <div class="row justify-content-center">
            <div class="col-md-6 text-center">
                <h2>Logging out...</h2>
                <p>Please wait while we log you out.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Logout',
    mounted() {
        this.performLogout();
    },
    methods: {
        performLogout() {
            // Check if auth is available
            if (this.$auth && this.$auth.auth0Client) {
                this.$auth.logout({
                    returnTo: process.env.VUE_APP_ENV_LOGOUT_URL || window.location.origin
                });
            } else if (this.$auth && !this.$auth.auth0Client) {
                // Auth instance exists but client not ready yet, wait a bit
                setTimeout(() => this.performLogout(), 100);
            } else {
                // No auth available, manually clear and redirect
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = process.env.VUE_APP_ENV_LOGOUT_URL || window.location.origin;
            }
        }
    }
}
</script>

<style scoped>
</style>
